import { createFileRoute } from '@tanstack/react-router';
import { publicHead } from '@/features/public/PublicLayout';
import { ExplorePage } from '@/features/public/ExplorePage';
import { validateExploreSearch } from '@/features/public/filters';

export const Route = createFileRoute('/explore/')({
  validateSearch: validateExploreSearch,
  head: () =>
    publicHead(
      'Explore listings',
      'Curated powered sites and datacenter capacity in Europe, introduced on request.',
    ),
  component: ExploreRoute,
});

function ExploreRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ExplorePage
      search={search}
      onSearchChange={(next) => navigate({ search: next, replace: true, resetScroll: false })}
    />
  );
}
